import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAttachment } from '@obvious.tech/constellation'

export const Attachment = defineEntity('Attachment', {
  endpoint: 'alarms/api/Attachment',
  schema: SNoop<IAttachment>(),
})
